import React from 'react'
import { useNavigate } from 'react-router-dom'

import sprite from '../assets/img/svg/svg-sprite.svg'
import { useAppDispatch, useAppSelector } from '../store'
import { useRevokePushTokenMutation } from '../store/api/api'
import { slice as authSlice } from '../store/auth'

interface Props {
  close: () => void
}

const Profile: React.FC<Props> = ({ close }) => {
  // --- EXTERNAL STATE ---//

  const navigate = useNavigate()

  const dispatch = useAppDispatch()

  const user = useAppSelector((state) => state.auth.user)

  const pushToken = useAppSelector((state) => state.auth.pushToken)

  const [revokePushToken] = useRevokePushTokenMutation()

  const closeProxy = () => {
    close()
  }

  const logout = async () => {
    // Отзываем токен на бэкенде, пока auth-заголовок ещё валиден (до reset).
    // Ошибку глотаем — выход не должен блокироваться сбоем сети.
    if (pushToken) {
      try {
        await revokePushToken({ token: pushToken }).unwrap()
      } catch {
        // ignore
      }
    }
    dispatch(authSlice.actions.reset())
    navigate('/login')
  }

  // --- RENDERING --- //

  return (
    <>
      <div className="overlay overlay_active" onClick={closeProxy}></div>
      <div className="popup-page__content">
        <div className="popup-page__body">
          <div className="popup-page__name">{user?.username ?? ''}</div>
          <a className="popup-page__te sl" href={`mailto://${user?.email}`}>
            {user?.email ?? ''}
          </a>
        </div>
        <div className="button__div">
          <button className="popup-page__logout" onClick={logout}>
            <svg width="24" height="24">
              <use xlinkHref={sprite + '#icon-logout'} />
            </svg>
            Выйти
          </button>
        </div>
      </div>
    </>
  )
}

export default Profile
